import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import Visual1 from '../assets/Services/Visuals.png';
import Visual2 from '../assets/Services/Visuals_2.png';

const VisualPage = () => (
  <div className="service-page service-page--studio-child">
    <Helmet>
      <title>Images & Video for Musicians | Westchester NY</title>
      <meta
        name="description"
        content="Photo and video services for musicians in Westchester. Artist branding, promo clips, and social content creation."
      />
    </Helmet>

    <Breadcrumbs />
    <h1>Images &amp; Video</h1>
    <br />

    {/* Row 1 */}
    <div className="studio-child-row">
      <div className="studio-child-text">
        <p>
          <img
            className="float-image-left"
            src={Visual1}
            alt="Photographer and videographer shooting a performance"
          />
          A compelling online identity is the difference between “pretty good” and “booked.” At <strong>The Westchester Music Lab</strong>, we create professional photo and video content for musicians — from high-energy live performance shoots to clean in-studio sessions and social-ready promo clips. We also support your visual brand with custom graphics, logos, and merch-ready designs so your content looks consistent everywhere it shows up.
        </p>
      </div>
    </div>

    <br />

    {/* Row 2 */}
    <div className="studio-child-two-col">
      <div className="studio-child-two-col-text">
        <h2 className="studio-child-heading">Services Included</h2>
        <ul>
          <li>Live performance shoots</li>
          <li>Edited promo video clips</li>
          <li>Studio session photography</li>
          <li>Artist branding and logo design</li>
          <li>Flyers and merch graphics</li>
          <li>Social media content creation</li>
        </ul>
      </div>

      <div className="studio-child-two-col-image">
        <img
          src={Visual2}
          alt="Visual editor editing content"
          className="service-image"
        />
      </div>
    </div>

    <br />

    <div className="service-cta">
      <Link to="/contact" className="cta-button">
        Request Rates for Photo &amp; Video Services
      </Link>
    </div>
  </div>
);

export default VisualPage;
